<!-- 服务账单 -->
<template>
    <div>
    	<van-nav-bar
		  	:title="$t('ServiceBill.title')"
			left-arrow
			fixed
		  	@click-left="$router.push('/Center')">
		</van-nav-bar>
		<van-cell>
			<van-row>
				<van-col span="8">{{$t('ServiceBill.time')}}</van-col>
				<van-col span="8">{{$t('ServiceBill.shopName')}}</van-col>
				<van-col span="6">{{$t('ServiceBill.num')}}</van-col>
			</van-row>
		</van-cell>
    	<van-cell v-for='(item,index) in bills' :key='index'>
    		<van-row>
			  	<van-col span="8">{{item.created_at}}</van-col>
			  	<van-col span="8" v-if="item.category==1">{{$t('ServiceBill.ActivateStore')}}</van-col>
				<van-col span="8" v-if="item.category==2">{{$t('ServiceBill.RechargePoints')}}</van-col>
			  	<van-col span="6">{{item.number}}</van-col>
			</van-row>
    	</van-cell>	
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				bills:{}
  			}
  		},
  		mounted(){
  			this.getServiceBill();
  		},
  		methods:{
  			//获取服务账单
  			getServiceBill(){
  				this.$axios({
	                method: 'get',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/user/bill',
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	            		this.bills=res.data.data;
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	                this.$toast({
	            		type:'fail',
	            		message:this.$t('ServiceBill.message')
	        		});
	            });
  			}
  		}

  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #FFF;
	}
	.van-row{
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/Shop/ServiceBill.vue